import useDeepCompareEffect from 'hooks/useDeepCompareEffect';
import { useDispatch } from 'react-redux';
import { publishAlert } from 'actions';
import { TOAST_TYPES } from 'components/common_v2/toasts/';

const canPublishError = (errorMessage, response) => errorMessage && response.error;

const canPublishSuccess = (successMessage, response) => successMessage && response.data;

export const useResponseToasts = (
  response,
  errorMessage = null,
  successMessage = null,
  duration = 4000
) => {
  const dispatch = useDispatch();
  useDeepCompareEffect(() => {
    if (canPublishError(errorMessage, response)) {
      dispatch(
        publishAlert({
          type: TOAST_TYPES.ERROR,
          message: errorMessage,
          duration,
        })
      );
    } else if (canPublishSuccess(successMessage, response)) {
      dispatch(
        publishAlert({
          type: TOAST_TYPES.SUCCESS,
          message: successMessage,
          duration,
        })
      );
    }
  }, [response]);
};

export default useResponseToasts;
